import React, { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import Landing from "./Components/Landing";
import Profile from "./Components/Profile";
import { MyCourses } from "./Components/Profile";
import Course from "./Components/Course";
import Post, { PostOutput } from "./Components/Community/Post";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./fontawesome-free-6.3.0-web/fontawesome-free-6.3.0-web/css/all.css";

import { toast, ToastContainer } from "react-toastify";
import "../node_modules/react-toastify/dist/ReactToastify.css";
import Footer from "./Components/Footer";

function App() {
  // ======== enrolled checking and toast notification fuctionality =============
  const [enrolled, setEnrolled] = useState(false);
  useEffect(() => {
    if (!enrolled) {
      setTimeout(() => {
        toast.success(
          <span lang="ar" dir="rtl">
            ﻹكمال الكورس عليك إكمال التسجيل بالذهاب إلى Payment
          </span>,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false,
          }
        );
      }, 30000);
    }
    if (enrolled) {
      clearTimeout();
    }
  }, []);
  return (
    <>
      <ToastContainer />

      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
          <Link to="/" class="navbar-brand" href="#">
            Daris
          </Link>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <Link
                  to="/"
                  class="nav-link active"
                  aria-current="page"
                  href="#"
                >
                  Home
                </Link>
              </li>
              <li class="nav-item">
                {/* <Link to="/profile" class="nav-link" href="#">
                </Link> */}
                <a href="#" className="nav-link">
                  About
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dropdown
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a class="dropdown-item" href="#">
                      Action
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#">
                      Another action
                    </a>
                  </li>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li>
                    <a class="dropdown-item" href="#">
                      Something else here
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link disabled"
                  href="#"
                  tabIndex="-1"
                  aria-disabled="true"
                >
                  Disabled
                </a>
              </li>
            </ul>
            <form class="d-flex">
              <input
                class="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button class="btn btn-outline-success" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>

      <Routes>
        <Route path="*" element={<Landing />} />
        <Route path="/profile/*" element={<Profile />} />
        <Route path="/mycourses/*" element={<MyCourses />} />
        <Route path="/course/*" element={<Course />} />
      </Routes>
      <Footer className="fixed-bottom" />
    </>
  );
}

export default App;
